export default function convertScheduleToRbcEvents(schedule) {
 
  return schedule.map((r)=>{
    
    let state = r.lState == 1 ? __("Attended", "schedule.calendar") : ''

    return {
      title: r.class_name + ' (' + __("Lesson", "schedule.calendar") + r.lesson_number + ')',
      state,
      allDay: false, 
      start: new Date(r.lStartTime.replace(/-/g, '/')), 
      end: new Date(r.lEndTime.replace(/-/g, '/')), 
      ...r,
    }

  });

}



// WEBPACK FOOTER //
// ./src/containers/pages/Schedule/convertScheduleToRbcEvents.js